import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.total > _vm.pageSize)?_c(VPagination,{staticClass:"normal px-1",attrs:{"circle":false,"length":_vm.totalPages,"total-visible":12},on:{"input":_vm.onMovePage},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e(),_c('div',{staticClass:"mobile"},[_c('MobilePagination',{attrs:{"pageSize":_vm.pageSize,"total":_vm.total}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }